import LinkWrapper from "@/components/LinkWrapper";
import FaChevronDown from "../SVG/Fontawesome/FaChevronDown";
import FaChevronRight from "../SVG/Fontawesome/FaChevronRight";
import { allenCourseNavigationData, courseNavigationData, examNavigationData, getNcertNavigationData } from "@/config/navigation";
import { INavItem } from "./interface";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCourseEnabled } from "@/store/slices/auth";

const NavItem = (props: { data: INavItem }) => {
  if (props.data.url && !props.data.content) {
    return (
      <li>
        <LinkWrapper href={props.data.url} className="w-52 no-underline flex items-center gap-2 hover:text-accent py-3 px-8" >
          {props.data.name}
        </LinkWrapper>
        <hr />
      </li>
    );
  }
  if (!props.data.content) {
    return null;
  }
  return (
    <li className="dropdown">
      <LinkWrapper href={props.data.url || "#"} role="button" type="button" className="w-52 no-underline flex justify-between items-center gap-2 hover:text-accent py-3 pl-8 pr-2">
        <span>{props.data.name}</span>
        <FaChevronRight className="w-8" />
      </LinkWrapper>
      <hr />
      <div className="dropdown-content absolute hidden z-[1000] ml-52 -mt-12 px-0.5">
        <ul className="rounded-md w-max border-none bg-secondary-light bg-clip-padding shadow-lg">
          {
            props.data.content.map((x, index) => <NavItem key={index.toString()} data={x} />)
          }
        </ul>
      </div>
    </li>
  )
}

const MultiDropdown = (props: {
  id: string;
  name: string;
  data: INavItem[];
}) => {
  return (
    <li>
      <div className="dropdown inline-block relative">
        <button id={props.id} name={props.id} className="w-max">
          <div className="text-sm	border-transparent font-semibold border-b-4 hover:border-border-brand-active pb-2 ease-in-out">
            <span >{props.name}</span>
          </div>
        </button>
        <ul className="dropdown-content absolute left-0 right-0 hidden z-[1000] mt-0 rounded-md w-max border-none bg-secondary-light bg-clip-padding shadow-lg">
          {
            props.data.map((item, index) => <NavItem key={index.toString()} data={item} />)
          }
        </ul>
      </div>
    </li>
  );
}

const CoursesDropdown = () => {
  const courseEnabled = useSelector(selectCourseEnabled);
  const courseDropdown = useMemo(() => {
    if (!courseEnabled) return [];
    return [{
      name: "My Course",
      url: "/my-course",
    }];
  }, [courseEnabled])

  return <MultiDropdown id="courses-btn" name="Courses" data={[...courseDropdown, ...courseNavigationData]} />
}

const Navbar = () => {
  const ncertNavigationData = getNcertNavigationData();

  return (
    <nav className="hidden lg:flex relative self-end pb-3  w-full items-center justify-between grow max-w-[10rem]">
      <div className="!visible hidden grow items-center lg:!flex">
        <ul className="list-none pl-0 flex flex-row items-center gap-8">
          <CoursesDropdown />
          <MultiDropdown id="ncert-solutions-btn" name="Ncert Solutions" data={ncertNavigationData[0].content} />
          <MultiDropdown id="exam-btn" name={examNavigationData.name} data={examNavigationData.content} />
          <li className="self-start">
            <LinkWrapper id="results-btn" href="/results" className="text-sm no-underline font-semibold w-max border-transparent border-b-4 hover:border-border-brand-active pb-2 ease-in-out">Results</LinkWrapper>
          </li>
          <MultiDropdown id="allen-courses-btn" name="Study with ALLEN" data={allenCourseNavigationData.content} />
        </ul>
      </div>
    </nav>
  );
}


export default Navbar;